import { render, staticRenderFns } from "./ModalSchedule.vue?vue&type=template&id=0bed2e50&"
import script from "./ModalSchedule.vue?vue&type=script&lang=js&"
export * from "./ModalSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports